import { useCallback, useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { JobsTable } from "@/components/jobs/JobsTable";

const FILTERS = ["all", "queued", "processing", "completed", "failed"];

export default function JobsQueue() {
  const nav = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [filter, setFilter] = useState("all");
  const [stats, setStats] = useState({});
  const [costs, setCosts] = useState(null);
  const [params] = useSearchParams();
  const mediaFilter = params.get("media");

  const load = useCallback(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).catch(() => {});
    api.get("/jobs/stats").then((r) => setStats(r.data.by_status || {})).catch(() => {});
    api.get("/costs").then((r) => setCosts(r.data.totals)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 2500); return () => clearInterval(t); }, [load]);

  const onAction = async (action, job) => {
    try {
      if (action === "delete") {
        if (!window.confirm("Delete this job and its stems?")) return;
        await api.delete(`/jobs/${job.id}`);
      } else await api.post(`/jobs/${job.id}/${action}`);
      toast.success(`Job ${action === "delete" ? "deleted" : action === "retry" ? "re-queued" : "cancelled"}`);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Action failed");
    }
  };

  const visible = jobs.filter((j) => (filter === "all" || j.status === filter) && (!mediaFilter || j.media_id === mediaFilter));
  return (
    <div data-testid="jobs-queue-dashboard" className="space-y-4 fade-up">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight">Jobs Queue</h1>
          <p className="text-sm text-slate-400 mt-1">Processing history with engine, model and cost metadata. Auto-refreshes.</p>
        </div>
        <div className="flex gap-3 items-center flex-wrap">
          {costs && (
            <button data-testid="jobs-spend-widget" onClick={() => nav("/costs")} className="panel px-3 py-1.5 text-xs font-mono flex items-center gap-3 hover:bg-[#1E2738]">
              <span className="micro">Spend</span>
              <span className="text-emerald-300">{Object.entries(costs.spend || {}).filter(([u]) => u).map(([u, v]) => `${v.toFixed(2)} ${u}`).join(" · ") || "0"}</span>
              <span className="text-slate-500">{costs.minutes} min</span>
            </button>
          )}
          <div className="flex gap-1">
          {FILTERS.map((f) => (
            <button key={f} data-testid={`jobs-filter-${f}`} onClick={() => setFilter(f)}
              className={`px-3 py-1.5 rounded-sm text-xs font-mono uppercase tracking-wider border transition-colors ${filter === f ? "border-cyan-500 bg-cyan-500/10 text-white" : "border-[#253044] text-slate-400 hover:bg-[#1E2738]"}`}>
              {f} {f !== "all" && stats[f] ? `· ${stats[f]}` : ""}
            </button>
          ))}
          </div>
        </div>
      </div>
      <JobsTable jobs={visible} onAction={onAction} />
    </div>
  );
}
